module.exports = __webpack_public_path__ + "./images/9b3f0467081f54a8bb6075546c4dc050.webp";